import React from 'react';
import PropTypes from 'prop-types';
import { ShareButtons as Buttons, generateShareIcon } from 'react-share';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ShareButtons.css';

class ShareButtons extends React.Component {
  static propTypes = {
    link: PropTypes.string.isRequired,
    iconSize: PropTypes.number.isRequired,
  };

  render() {
    const { link, iconSize } = this.props;
    const { FacebookShareButton, TwitterShareButton, TelegramShareButton } = Buttons;

    const FacebookIcon = generateShareIcon('facebook');
    const TwitterIcon = generateShareIcon('twitter');
    const TelegramIcon = generateShareIcon('telegram');

    return (
      <div className={s.root}>
        <FacebookShareButton className={s.button} url={link}>
          <FacebookIcon size={iconSize} />
        </FacebookShareButton>
        <TwitterShareButton className={s.button} url={link}>
          <TwitterIcon size={iconSize} />
        </TwitterShareButton>
        <TelegramShareButton className={s.button} url={link}>
          <TelegramIcon size={iconSize} />
        </TelegramShareButton>
      </div>
    );
  }
}

export default withStyles(s)(ShareButtons);



// WEBPACK FOOTER //
// ./src/desktop/components/ShareButtons/ShareButtons.js